export default function Videos() {
  const videos = [
    {
      id: 1,
      title: "JOY + PAIN FEAT. BO ROC- OFFICIAL MUSIC VIDEO",
      thumbnail: "https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/7ed99b6e3eb7b03d5c661d6923662fd8.jpeg",
      views: "2.5M",
      date: "2 weeks ago",
      link: "https://music.youtube.com/watch?v=YffhQBBbnNQ&si=ObuK7IIHrkNrzim-"
    },
    {
      id: 2,
      title: "PULL UP FEAT. EDI Mean & C-BO- OFFICIAL MUSIC VIDEO",
      thumbnail: "https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/031635db2ee2bf365e45bba2230ccf97.png",
      views: "1.8M",
      date: "1 month ago",
      link: "https://youtu.be/RzViPKKBYCU?si=oJUtreFHRxDhfQ1Z"
    },
    {
      id: 3,
      title: "ALL IN FEAT. THA REALEST- OFFICIAL MUSIC VIDEO",
      thumbnail: "https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/f495d027f7cf2e94cb7eccc847e55352.jpeg",
      views: "3.2M",
      date: "2 months ago",
      link: "https://youtu.be/28kzAhZgla8?si=O9hXMC1Uhs8ZdvIG"
    },
    {
      id: 4,
      title: "HOOD NIGGA FEAT. THA REALEST- OFFICIAL mUSIC vIDEO",
      thumbnail: "https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/21f11f8511c18ce791d6cf0ff67fc816.png",
      views: "1.5M",
      date: "3 months ago",
      link: "https://youtu.be/OEf32vbOhI0?si=dJOZX_dmEvIsBxii"
    },
    {
      id: 5,
      title: "YESTERDAY'S PRYCE FEAT. THA REALEST- OFFICIAL MUSIC VIDEO",
      thumbnail: "https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/4810795e59274a64cd9a086260592613.png",
      views: "980K",
      date: "4 months ago",
      link: "https://youtu.be/OEf32vbOhI0?si=dJOZX_dmEvIsBxii"
    }
  ];

  return (
    <section id="videos" className="py-32 px-6 lg:px-20 bg-[#8B0000]">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-6xl lg:text-7xl font-bold text-white relative inline-block">
            MUSIC VIDEOS
            <span className="absolute -inset-2 bg-white opacity-20 blur-xl -z-10"></span>
          </h2>
        </div>

        {/* Videos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video, index) => (
            <a
              key={video.id}
              href={video.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`group cursor-pointer ${
                video.featured ? 'md:col-span-2 md:row-span-1' : ''
              } ${index === 5 ? 'hidden md:block' : ''}`}
            >
              <div className="relative overflow-hidden rounded-xl bg-black">
                {video.featured && (
                  <div className="absolute top-4 left-4 z-10 px-3 py-1 bg-white text-[#E31E24] text-xs font-bold rounded-full">
                    NEW
                  </div>
                )}
                
                <div className={`relative ${video.featured ? 'aspect-video' : 'aspect-video'} overflow-hidden`}>
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-500"
                  />
                  
                  {/* Play Button Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/50 transition-all duration-300">
                    <div className="w-20 h-20 flex items-center justify-center bg-white/90 rounded-full group-hover:scale-110 group-hover:bg-white transition-all duration-300">
                      <i className="ri-play-fill text-4xl text-[#8B0000] ml-1"></i>
                    </div>
                  </div>

                  {/* Neon Border on Hover */}
                  <div className="absolute inset-0 border-4 border-transparent group-hover:border-white rounded-xl transition-all duration-300"></div>
                </div>
              </div>

              <div className="mt-4">
                <h3 className="text-lg font-bold text-white group-hover:text-white/80 transition-all duration-300">
                  {video.title}
                </h3>
              </div>
            </a>
          ))}

          {/* More Videos CTA Card - REMOVED */}
        </div>
      </div>
    </section>
  );
}
